import { useContext, createElement } from "react";
import { SystemContext } from "./auth-service-tools658.js";
import { a as _objectWithoutPropertiesLoose } from "./auth-service-tools632.js";

function isRenderProp(children) {
  return typeof children === "function";
}

var useCreateElement = function useCreateElement2(type, props, children) {
  if (children === void 0) {
    children = props.children;
  }

  var context = useContext(SystemContext);

  if (context.useCreateElement) {
    return context.useCreateElement(type, props, children);
  }

  if (typeof type === "string" && isRenderProp(children)) {
    props.children;

    var rest = _objectWithoutPropertiesLoose(props, ["children"]);

    return children(rest);
  }

  return /* @__PURE__ */createElement(type, props, children);
};

export { useCreateElement };